import { Link } from "gatsby"
import * as React from "react"
import Layout from "../components/layout"

const IndexPage = () => {
  return (
    <Layout>
      <div className="row">
        <div className="col">
          <h3 className="instruction__heading instruction__heading_h3"><Link to="lms/">Для регистрации в СЭО МАИ</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="education/">Для регистрации почты в домене mai.education</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="videoincourse/">Инструкция по размещению видео в курсе СЭО МАИ</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="ldap/">Инструкция по переходу на единую авторизацию МАИ</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="mobile/">Для регистрации в СЭО МАИ с мобильного приложения</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="bigbluebutton/">Инструкция по использованию видеоконференции BigBlueButton</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="teamsmeeting/">Создание и настройка элемента курса «Собрание MS Teams»</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="fortutors/">Работа с системой обучения для преподавателя</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="forstudents/">Работа с системой обучения для студента</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="video/">Видеоинструкция по работе с СЭО МАИ</Link></h3>
          <h3 className="instruction__heading instruction__heading_h3"><Link to="contacts/">Контакты</Link></h3>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
